import { LoginForm } from "@/components/auth/login-form";
import { LanguageSwitcher } from "@/components/language-switcher";

export function LoginPage() {
	return (
		<div className="relative flex min-h-svh w-full items-center justify-center p-6 md:p-10">
			<div className="absolute top-4 right-4">
				<LanguageSwitcher variant="dark" />
			</div>
			<div className="w-full max-w-sm">
				<LoginForm />
			</div>
		</div>
	);
}
